import { rectSortingStrategy, SortableContext } from '@dnd-kit/sortable'
import type { ViewFieldsFragment } from '@salescore/client-api'
import type { CompiledFormViewConfig, ViewUICol, ViewUIRow } from '@salescore/core'
import { Row } from 'antd'
import type React from 'react'
import { type ReactElement, useContext } from 'react'

import type { SalescoreObjectAbility, ViewAbility } from '../../recoil/view/atoms'
import { ViewUIContext, ViewUIFormComponentC } from './ViewUIComponent'

const SortableContextWrapper: React.FC<{ isEditMode: boolean; cols: ViewUICol[]; children: ReactElement }> = ({
  isEditMode,
  cols,
  children,
}) => {
  if (!isEditMode) {
    return <>{children}</>
  }

  return (
    <SortableContext items={cols} strategy={rectSortingStrategy}>
      {children}
    </SortableContext>
  )
}

export const ViewUIRowC = ({
  component,
  compiledConfig,
  showError,
  view,
  ability,
}: {
  component: ViewUIRow
  compiledConfig: CompiledFormViewConfig
  showError: boolean
  view: ViewFieldsFragment
  ability: ViewAbility & SalescoreObjectAbility
}): ReactElement => {
  const { isEditMode } = useContext(ViewUIContext)

  return (
    <Row gutter={component.gutter ?? 16} className="mb-5">
      <SortableContextWrapper isEditMode={isEditMode} cols={component.children}>
        <>
          {component.children.map((child) => (
            <ViewUIFormComponentC
              key={child.id}
              component={child}
              compiledConfig={compiledConfig}
              showError={showError}
              view={view}
              ability={ability}
            />
          ))}
        </>
      </SortableContextWrapper>
    </Row>
  )
}
